if (!customElements.get("podcast-page-list-hot")) {
  customElements.define(
    "podcast-page-list-hot",

    class PodcastPageList extends HTMLElement {
      constructor() {
        super();
        const pageUrl = window.location.href
          .replace(window.shopUrl, "")
          .split("?")[0];
        this.pageToFetch = `${pageUrl}?view=podcasts-list-hot&section_id=podcast-list-standalone-hot`;

        // Initialize an array to store the HTML content of each fetched blog article
        this.fetchedArticles = [];
        this.currentPage = 1;
        this.articlesPerPage = 8;

        // Create the pagination wrapper
        this.paginationWrapper = document.createElement('div');
        this.paginationWrapper.classList.add('pagination-wrapper-podcast');
        this.parentElement.appendChild(this.paginationWrapper);

        (async () => {
          this.pagesCount = await this.findPagesCount();
          console.log(this.pagesCount);

          await Promise.allSettled(
            Array.from({ length: this.pagesCount }, (_, i) =>
              this.fetchPodcastSection(i + 1)
            )
          );

          // Sort the fetched articles by their title in descending order
          this.fetchedArticles.sort((a, b) => {
            const titleA = a.querySelector('.article-card-wrapper').getAttribute('data-title').match(/\d+/)[0];
            const titleB = b.querySelector('.article-card-wrapper').getAttribute('data-title').match(/\d+/)[0];
            return parseInt(titleB) - parseInt(titleA);
          });

          // Display the first page of articles
          this.displayPage(this.currentPage);

          // Create pagination
          this.createPagination();

          this.querySelector(".loader").remove();
        })();
      }

      async findPagesCount() {
        console.log(this.pageToFetch);
        const res = await fetch(this.pageToFetch);

        const html = await res.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, "text/html");
        const pages = Array.from(doc.querySelectorAll(".page"));

        return parseFloat(pages[pages.length - 1].innerText);
      }

      async fetchPodcastSection(page = 1) {
        const res = await fetch(`${this.pageToFetch}&page=${page}`);
        const html = await res.text();

        const parser = new DOMParser();
        const doc = parser.parseFromString(html, "text/html");

        // Extract the blog articles and store them in the array
        const articles = Array.from(doc.querySelectorAll(".blog-articles__article"));
        articles.forEach((article) => this.fetchedArticles.push(article));
      }

      displayPage(pageNumber) {
        // Clear the current articles
        this.querySelectorAll('.blog-articles__article').forEach(article => article.remove());

        // Calculate start and end index for the articles to display
        const startIndex = (pageNumber - 1) * this.articlesPerPage;
        const endIndex = startIndex + this.articlesPerPage;
        const articlesToDisplay = this.fetchedArticles.slice(startIndex, endIndex);

        // Append the articles for the current page
        articlesToDisplay.forEach((article) => this.append(article));

        // Ensure the pagination wrapper is visible
        this.paginationWrapper.style.display = 'flex';

        // Update the pagination dynamically
        this.createPagination();

        // Update the active class for pagination buttons
        document.querySelectorAll('.pagination-button').forEach(button => button.classList.remove('active'));
        const activeButton = document.querySelector(`.pagination-button[data-page="${pageNumber}"]`);
        if (activeButton) {
          activeButton.classList.add('active');
        }
      }

      createPagination() {
        const totalPages = Math.ceil(this.fetchedArticles.length / this.articlesPerPage);

        // Clear existing pagination buttons
        this.paginationWrapper.innerHTML = '';

        // Helper function to create a page button
        const createPageButton = (i) => {
          const pageButton = document.createElement('button');
          pageButton.textContent = i;
          pageButton.classList.add('pagination-button');
          pageButton.setAttribute('data-page', i); // Add data attribute for page number
          if (i === this.currentPage) {
            pageButton.classList.add('active');
          }
          pageButton.addEventListener('click', () => {
            this.currentPage = i;
            this.displayPage(i);
          });
          return pageButton;
        };

        // Add first page
        this.paginationWrapper.appendChild(createPageButton(1));

        // Add ellipsis if necessary
        if (this.currentPage > 4) {
          const ellipsis = document.createElement('span');
          ellipsis.textContent = '...';
          this.paginationWrapper.appendChild(ellipsis);
        }

        // Add pages around the current page
        for (let i = Math.max(2, this.currentPage - 1); i <= Math.min(totalPages - 1, this.currentPage + 1); i++) {
          this.paginationWrapper.appendChild(createPageButton(i));
        }

        // Add ellipsis if necessary
        if (this.currentPage < totalPages - 3) {
          const ellipsis = document.createElement('span');
          ellipsis.textContent = '...';
          this.paginationWrapper.appendChild(ellipsis);
        }

        // Add last page
        if (totalPages > 1) {
          this.paginationWrapper.appendChild(createPageButton(totalPages));
        }

        // Ensure the pagination wrapper is visible when created
        this.paginationWrapper.style.display = 'flex';
      }
    }
  );
}